export default class TurnoService {
  constructor(resource) {
    this._resource = resource;
  }

  getTurnosColegio() {
    return this._resource.get(`corpore/turno/colegio`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os turnos do colégio");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/TurnoService.js